import Raven from 'raven-js';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
const AllSupportedProductLines = ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'];
export const getHighlightsForProductLine = productLine => {
  const {
    highlightedFreeProduct,
    highlightedProducts
  } = FullProductLineMap[productLine];
  return [...(highlightedFreeProduct ? [highlightedFreeProduct] : []), ...highlightedProducts];
};
export const getAllFreeProducts = () => {
  const productLines = Object.keys(FullProductLineMap);
  return productLines.map(productLine => {
    return FullProductLineMap[productLine].highlightedFreeProduct || null;
  });
};
export const getProductLevelFromApiNameString = apiName => {
  const segments = apiName.split('-');
  if (segments[0] === 'breeze') {
    return 'STARTER';
  }
  const productLevel = segments.find(item => {
    return currentOrderedProductLevels.includes(item.toUpperCase());
  });
  if (!productLevel) {
    const error = new Error('Failed to find productLevel from apiName');
    Raven.captureException(error, {
      extra: {
        apiName
      }
    });
    console.error('Failed to find productLevel from apiName', apiName);
    throw error;
  }
  return productLevel.toUpperCase();
};
export const getProductLineFromApiNameString = apiName => {
  const segments = apiName.split('-');
  const productLine = segments.find(segment => AllSupportedProductLines.includes(segment.toUpperCase()));
  if (!productLine) {
    const error = new Error('Failed to find productLine from apiName');
    Raven.captureException(error, {
      extra: {
        apiName
      }
    });
    throw error;
  }
  return productLine.toUpperCase();
};
export const buildFilteredHighlightedProducts = ({
  productLine,
  productLevels
}) => {
  const highlightedProducts = getHighlightsForProductLine(productLine);
  const pseudoHubs = ['breeze-intelligence-credits-100', 'breeze-intelligence-credits-1000', 'breeze-intelligence-credits-10000'];
  return highlightedProducts.filter(apiName => {
    if (pseudoHubs.includes(apiName)) {
      return false;
    }
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
};